/* Shades of India - toast notifications and the wishlist (favourites).
 * Theme-only: the wishlist lives in the browser (localStorage), so it works for guests and customers alike and
 * does not need an app. Cards on the wishlist page are rendered by Shopify (product template view "card"), so they
 * look exactly like the collection grid.
 */
(() => {
  if (window.__soiExtras) return;
  window.__soiExtras = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast: large, centred, animated icon, closes by itself ---------- */
  const ICONS = {
    cart: '<svg viewBox="0 0 64 64" aria-hidden="true"><circle class="t-ring" cx="32" cy="32" r="28" fill="none" stroke="currentColor" stroke-width="3"/><path class="t-tick" d="M19 33l9 9 17-19" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    heart: '<svg viewBox="0 0 64 64" aria-hidden="true"><circle class="t-ring" cx="32" cy="32" r="28" fill="none" stroke="currentColor" stroke-width="3"/><path class="t-heart" d="M44.6 20.4a8.6 8.6 0 0 0-12.2 0L32 20.8l-.4-.4a8.6 8.6 0 0 0-12.2 12.2l.4.4L32 45.2l12.2-12.2.4-.4a8.6 8.6 0 0 0 0-12.2z" fill="currentColor"/></svg>',
    info: '<svg viewBox="0 0 64 64" aria-hidden="true"><circle class="t-ring" cx="32" cy="32" r="28" fill="none" stroke="currentColor" stroke-width="3"/><path class="t-tick" d="M32 20v16M32 43v1" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round"/></svg>',
  };
  let toastEl; let toastTimer;
  const toast = (message, type = 'info', sub = '') => {
    if (!message) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'soi-xtoast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML = '<div class="soi-xtoast__card"><div class="soi-xtoast__icon"></div><p class="soi-xtoast__msg"></p><p class="soi-xtoast__sub"></p></div>';
      document.body.appendChild(toastEl);
    }
    const kind = ICONS[type] ? type : 'info';
    toastEl.dataset.type = kind;
    // re-insert the svg so the draw animation replays every time
    $('.soi-xtoast__icon', toastEl).innerHTML = ICONS[kind];
    $('.soi-xtoast__msg', toastEl).textContent = message;
    const s = $('.soi-xtoast__sub', toastEl);
    s.textContent = sub || '';
    s.hidden = !sub;
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };
  window.SOI_TOAST = toast;

  // Added to bag: every add (product page, quick add, cards, upsells) emits soi:cart:added
  document.addEventListener('soi:cart:added', (e) => {
    const items = (e.detail && e.detail.items) || [];
    const first = items[0] || {};
    const qty = items.reduce((n, i) => n + (Number(i.quantity) || 0), 0);
    const title = first.product_title || first.title || '';
    toast('Added to bag', 'cart', qty > 1 ? `${title}${title ? ' ' : ''}(${qty} items)` : title);
  });

  /* ---------- Wishlist ---------- */
  const KEY = 'soi:wishlist:v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  const write = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) { /* private mode */ } };
  let list = read();
  const has = (id) => list.some((i) => String(i.id) === String(id));

  const mark = () => {
    $$('[data-soi-wishlist]').forEach((b) => {
      const on = has(b.dataset.productId);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    $$('[data-soi-wishlist-count]').forEach((c) => { c.textContent = String(list.length); c.hidden = list.length === 0; });
  };
  const titleFor = (btn) => {
    const card = btn.closest('[data-soi-card]');
    const t = card && $('.collection-product-title', card);
    if (t) return t.textContent.trim();
    const qa = btn.closest('[data-qa-product]');
    const qt = qa && $('.soi-qa__title', qa);
    if (qt) return qt.textContent.trim();
    const h = $('.pdp-product-title');
    return h ? h.textContent.trim() : '';
  };
  const toggle = (btn) => {
    const id = btn.dataset.productId;
    const handle = btn.dataset.productHandle;
    if (!id) return;
    const on = has(id);
    if (on) list = list.filter((i) => String(i.id) !== String(id));
    else list.unshift({ id: String(id), handle, t: Date.now() });
    write(list);
    mark();
    toast(on ? 'Removed from wishlist' : 'Added to wishlist', 'heart', titleFor(btn));
    document.dispatchEvent(new CustomEvent('soi:wishlist:change', { detail: { list } }));
    return !on;
  };

  const page = $('[data-soi-wishlist-page]');
  const grid = page && $('[data-soi-wishlist-grid]', page);
  const empty = page && $('[data-soi-wishlist-empty]', page);
  const loading = page && $('[data-soi-wishlist-loading]', page);
  const countEl = page && $('[data-soi-wishlist-total]', page);
  const showEmpty = () => {
    if (!page) return;
    if (empty) empty.hidden = list.length > 0;
    if (grid) grid.hidden = list.length === 0;
    if (countEl) countEl.textContent = list.length ? `${list.length} ${list.length === 1 ? 'item' : 'items'}` : '';
  };
  const renderPage = async () => {
    if (!page || !grid) return;
    if (!list.length) { if (loading) loading.hidden = true; grid.innerHTML = ''; showEmpty(); return; }
    const cards = await Promise.all(list.map((i) =>
      fetch(`${root}products/${encodeURIComponent(i.handle)}?view=card`, { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : ''))
        .catch(() => '')));
    grid.innerHTML = '';
    cards.forEach((html, n) => {
      if (!html || !html.trim()) return;
      const wrap = document.createElement('div');
      wrap.className = 'soi-wishlist__item';
      wrap.innerHTML = html;
      // wrap carries the template so the quick add popup keeps working
      grid.appendChild(wrap);
    });
    if (loading) loading.hidden = true;
    mark();
    showEmpty();
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-soi-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const added = toggle(btn);
    if (added === false && btn.closest('[data-soi-wishlist-page]')) {
      const item = btn.closest('.soi-wishlist__item');
      if (item) { item.classList.add('is-leaving'); setTimeout(() => { item.remove(); showEmpty(); }, 260); }
    }
  }, true);

  // another tab changed the list
  window.addEventListener('storage', (e) => { if (e.key === KEY) { list = read(); mark(); if (page) renderPage(); } });
  document.addEventListener('soi:content:loaded', mark);
  const init = () => { mark(); renderPage(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---------- Collection "Load more" without a page refresh ---------- */
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-soi-load-more]');
    if (!more) return;
    if (window.SOI && window.SOI.filters && window.SOI.filters.enabled) return; // the app module handles it
    const rootEl = more.closest('[data-soi-filters-root]');
    const grid = rootEl && $('[data-soi-grid]', rootEl);
    if (!rootEl || !grid) return;
    e.preventDefault();
    if (more.classList.contains('is-loading')) return;
    more.classList.add('is-loading');
    const label = more.textContent;
    more.textContent = 'Loading…';
    try {
      const x = new URL(more.href, location.origin);
      x.searchParams.set('section_id', rootEl.dataset.sectionId);
      const html = await (await fetch(x.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      Array.from($('[data-soi-grid]', doc).children).forEach((n) => { if (!n.classList.contains('soi-empty')) grid.appendChild(document.importNode(n, true)); });
      const pag = $('[data-soi-filter-target="pagination"]', doc);
      const cur = $('[data-soi-filter-target="pagination"]', rootEl);
      if (pag && cur) cur.replaceWith(document.importNode(pag, true));
      mark();
      document.dispatchEvent(new CustomEvent('soi:content:loaded', { detail: { root: grid } }));
    } catch (err) {
      location.href = more.href;
    } finally {
      more.classList.remove('is-loading');
      more.textContent = label;
    }
  });

  /* ---------- Product page: zoom button opens the same lightbox as clicking the photo ---------- */
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-soi-zoom-open]');
    if (!z) return;
    e.preventDefault();
    const gallery = z.closest('[data-soi-gallery]');
    if (!gallery) return;
    const slide = $('.pdp-gallery-slide.active[data-soi-zoom]', gallery) || $('[data-soi-zoom]', gallery);
    if (slide) slide.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  });


  /* ---------- Hover fix ----------
   * The base theme (styles.css) turns EVERY <button> white with dark text on hover through a very specific selector
   * (button:not(.no-hover):...:hover), which beats the Shades hover styles: arrows, pills and CTAs lost their designed
   * hover state. The base theme itself exempts anything with .no-hover, so tag the buttons here (and any added later). */
  const tagButtons = (scope) => {
    const nodes = scope.querySelectorAll ? scope.querySelectorAll('button, input[type="submit"], .button') : [];
    nodes.forEach((b) => b.classList.add('no-hover'));
    if (scope.matches && scope.matches('button, input[type="submit"], .button')) scope.classList.add('no-hover');
  };
  tagButtons(document);
  if ('MutationObserver' in window) {
    new MutationObserver((muts) => {
      muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) tagButtons(n); }));
    }).observe(document.documentElement, { childList: true, subtree: true });
  }


  /* ---------- Product page: show the selected colour name next to "Colour:" ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.pdp-swatch');
    if (!sw) return;
    const group = sw.closest('.pdp-size-section');
    const out = group && $('[data-soi-option-selected]', group);
    if (out) out.textContent = sw.dataset.value || '';
  });

  /* ---------- Count-up numbers (Timeless . Texture . Textile: 200+ artisans, 30+ years) ---------- */
  const initCounters = () => {
    const nodes = $$('.stats-row .stat-num').filter((n) => !n.dataset.soiCounted);
    if (!nodes.length) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const parse = (txt) => {
      const m = String(txt).trim().match(/^([^\d]*)([\d][\d,]*(?:\.\d+)?)(.*)$/);
      if (!m) return null;
      const raw = m[2];
      return { prefix: m[1], value: parseFloat(raw.replace(/,/g, '')), decimals: (raw.split('.')[1] || '').length, commas: raw.includes(','), suffix: m[3] };
    };
    const fmt = (c, v) => {
      let t = v.toFixed(c.decimals);
      if (c.commas) { const [i, d] = t.split('.'); t = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (d ? '.' + d : ''); }
      return c.prefix + t + c.suffix;
    };
    const run = (el, c) => {
      const w = el.getBoundingClientRect().width;
      if (w) { el.style.display = 'inline-block'; el.style.minWidth = Math.ceil(w) + 'px'; }
      el.style.fontVariantNumeric = 'tabular-nums';
      const dur = 1800;
      const t0 = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const tick = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        el.textContent = fmt(c, c.value * ease(p));
        if (p < 1) requestAnimationFrame(tick); else el.textContent = c.final;
      };
      el.textContent = fmt(c, 0);
      requestAnimationFrame(tick);
    };
    nodes.forEach((el) => {
      const c = parse(el.textContent);
      if (!c) return;
      c.final = el.textContent.trim();
      el.dataset.soiCounted = '1';
      if (reduce || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          io.disconnect();
          run(el, c);
        });
      }, { threshold: 0.6 });
      io.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCounters); else initCounters();

  /* ---------- Story video: sound on / off (videos start muted so autoplay is allowed; the viewer opts in) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-soi-video-sound]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const frame = btn.closest('[data-soi-video-toggle]') || btn.parentElement;
    const video = frame && frame.querySelector('video');
    if (!video) return;
    video.muted = !video.muted;
    if (!video.muted) {
      video.volume = 1;
      if (video.paused) { delete video.dataset.userPaused; const p = video.play(); if (p && p.catch) p.catch(() => {}); }
    }
    btn.classList.toggle('is-on', !video.muted);
    btn.setAttribute('aria-pressed', String(!video.muted));
    btn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
  });

  /* ---------- Product page: "Pair it with" carousel (arrows + swipe; arrows only when something is off-screen) ---------- */
  const pairState = (box) => {
    const track = $('[data-soi-pair-track]', box);
    if (!track) return;
    const nav = $('[data-soi-pair-nav]', box);
    const prev = $('[data-soi-pair-prev]', box);
    const next = $('[data-soi-pair-next]', box);
    const max = track.scrollWidth - track.clientWidth;
    if (nav) nav.hidden = max <= 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  };
  const pairRefresh = () => $$('[data-soi-pair]').forEach(pairState);
  window.__soiPairRefresh = pairRefresh;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-soi-pair-prev], [data-soi-pair-next]');
    if (!btn) return;
    const box = btn.closest('[data-soi-pair]');
    const track = box && $('[data-soi-pair-track]', box);
    if (!track) return;
    const card = track.firstElementChild;
    const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12) : track.clientWidth * 0.8;
    const dir = btn.hasAttribute('data-soi-pair-next') ? 1 : -1;
    track.scrollBy({ left: dir * step * (window.innerWidth >= 1100 ? 1 : 2), behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (t && t.nodeType === 1 && t.matches && t.matches('[data-soi-pair-track]')) pairState(t.closest('[data-soi-pair]'));
  }, true);
  window.addEventListener('resize', pairRefresh);
  window.addEventListener('load', pairRefresh);
  document.addEventListener('DOMContentLoaded', pairRefresh);
  // images/fonts change the track width after first paint, and the automatic list is injected later by soi-core.js
  new MutationObserver(() => { clearTimeout(pairRefresh.t); pairRefresh.t = setTimeout(pairRefresh, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });

  window.SOI_WISHLIST = { list: () => list.slice(), has, toggle: (id, handle) => toggle({ dataset: { productId: id, productHandle: handle }, closest: () => null }) };
})();
